function RightArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.091 12 8 7.333 9.454 6 16 12l-6.546 6L8 16.667 13.091 12z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RightArrow;
